export type AmbitoId = 'desio' | 'vimercate' | 'monza' | 'seregno' | 'carate'

export interface AmbitoStat {
  id: AmbitoId
  nome: string
  maschi: number
  femmine: number
  popolazione: number
  km2: number
  densitaAbKm2: number
  numeroComuni: number
  comuni: string[]
}

export const AMBITI_STATS: AmbitoStat[] = [
  {
    id: 'desio',
    nome: 'Desio',
    maschi: 96045,
    femmine: 98353,
    popolazione: 194398,
    km2: 60,
    densitaAbKm2: 3258,
    numeroComuni: 7,
    comuni: ['Bovisio-Masciago', 'Cesano Maderno', 'Desio', 'Limbiate', 'Muggiò', 'Nova Milanese', 'Varedo'],
  },
  {
    id: 'vimercate',
    nome: 'Vimercate',
    maschi: 92616,
    femmine: 94640,
    popolazione: 187256,
    km2: 141,
    densitaAbKm2: 1325,
    numeroComuni: 22,
    comuni: [
      'Agrate Brianza',
      'Aicurzio',
      'Arcore',
      'Bellusco',
      'Bernareggio',
      'Burago di Molgora',
      'Busnago',
      'Camparada',
      'Caponago',
      'Carnate',
      'Cavenago di Brianza',
      'Concorezzo',
      "Cornate d'Adda",
      'Lesmo',
      'Mezzago',
      'Ornago',
      'Roncello',
      'Ronco Briantino',
      'Sulbiate',
      'Usmate Velate',
      'Vimercate',
      'Correzzana',
    ],
  },
  {
    id: 'monza',
    nome: 'Monza',
    maschi: 83564,
    femmine: 89230,
    popolazione: 172794,
    km2: 48,
    densitaAbKm2: 3581,
    numeroComuni: 3,
    comuni: ['Monza', 'Brugherio', 'Villasanta'],
  },
  {
    id: 'seregno',
    nome: 'Seregno',
    maschi: 83943,
    femmine: 86642,
    popolazione: 170585,
    km2: 80,
    densitaAbKm2: 2125,
    numeroComuni: 10,
    comuni: ['Barlassina', 'Ceriano Laghetto', 'Cogliate', 'Giussano', 'Lazzate', 'Lentate sul Seveso', 'Meda', 'Misinto', 'Seregno', 'Seveso'],
  },
  {
    id: 'carate',
    nome: 'Carate Brianza',
    maschi: 76122,
    femmine: 78597,
    popolazione: 154719,
    km2: 76,
    densitaAbKm2: 2035,
    numeroComuni: 13,
    comuni: ['Albiate', 'Besana in Brianza', 'Biassono', 'Briosco', 'Carate Brianza', 'Lissone', 'Macherio', 'Renate', 'Sovico', 'Triuggio', 'Vedano al Lambro', 'Veduggio con Colzano', 'Verano Brianza'],
  },
]

export const TOTALI_BACINO = {
  maschi: AMBITI_STATS.reduce((acc, ambito) => acc + ambito.maschi, 0),
  femmine: AMBITI_STATS.reduce((acc, ambito) => acc + ambito.femmine, 0),
  popolazione: AMBITI_STATS.reduce((acc, ambito) => acc + ambito.popolazione, 0),
  km2: AMBITI_STATS.reduce((acc, ambito) => acc + ambito.km2, 0),
  densitaAbKm2: Number((
    AMBITI_STATS.reduce((acc, ambito) => acc + ambito.popolazione, 0) /
    AMBITI_STATS.reduce((acc, ambito) => acc + ambito.km2, 0)
  ).toFixed(1)),
  numeroComuni: AMBITI_STATS.reduce((acc, ambito) => acc + ambito.numeroComuni, 0),
}
